import {IonButton, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonImg, IonLabel, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonAlert, useIonRouter} from '@ionic/react';
import {capitalize, productInfo} from '../utils';

import styles_7_2_2 from "./Pg_7_2_2.module.scss";
import {useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import {Fragment, useEffect, useRef, useState} from "react";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {PageHeader} from "./PageHeader";
import {TokenItem} from "../components/TokenItem";
import {Modal} from "./Modal";
import CustomPage from "./CustomPage";
import {useStoreState} from "pullstate";
import {getPageData} from "../store/Selectors";
import {fetch_pg_7_2_1, fetch_pg_7_2_2, Pg_7_2_1_Store, Pg_7_2_2_Store, push_pg_7_2_1__joinquiz, push_pg_7_2_2__competequiz} from "../store/Pg_7_Store";
import queryString from "query-string";
import {ContractBonusItem} from "../components/ContractBonusItem";
import {TokenEnwItem} from "../components/TokenEnwItem";
import {useParams} from "react-router";
import {chevronDownCircleOutline} from "ionicons/icons";
import {ContractBonusDetailItem} from "../components/ContractBonusDetailItem";
import {fetch_pg_0_3} from "../store/Pg_0_Store";
import {handleCommonFetchErrors, navToPg_7_2_2, navToPg_7_5, promptBrowserToLogin} from "./Utils";
import {AuthStore} from "../store/Common_Store";
import {CardDetailFor_7_2_1} from "../components/CardDetailFor_7_2_1";
import useForceRender from "../_/useForceRender";
import AriaModal from "../components/react-aria-modal/src/react-aria-modal";

const Pg_7_2_1 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_7_2_1";
    const pageId = "Pg_7_2_1";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    const forceRender = useForceRender();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const [presentAlert] = useIonAlert();

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    const {contractBonusId}: any = useParams();

    useEffect(() => {
        (async () => {
            let errorObj = await fetch_pg_7_2_2({
                p1: contractBonusId,
            });
            handleCommonFetchErrors(router, errorObj);
        })();
    }, [contractBonusId]);

    let reload = async (event: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_pg_7_2_2({
            p1: contractBonusId,
        });
        handleCommonFetchErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_7_2_2_Store, getPageData);
    const [amountLoaded, setAmountLoaded] = useState(20);
    const [selectedProduct, setSelectedProduct] = useState(false);

    const hasLoaded = pgData?.Root ?? false;
    const Item_Sdgs課程問題 = hasLoaded ? pgData.Root.Item_Sdgs課程問題 : undefined;
    const List_Sdgs課程答案 = hasLoaded ? pgData.Root.List_Sdgs課程答案 : undefined;
    const QuizToken = hasLoaded ? pgData.Root.QuizToken : undefined;
    const Item_Sdgs課程 = hasLoaded ? pgData.Root.Item_Sdgs課程 : undefined;

    //#endregion


    const wrongAnswerDialog = ()=> {
        presentAlert({
            backdropDismiss: false,
            keyboardClose: false,
            header: '錯誤答案，請重新選擇！',
            //subHeader: 'A Sub Header Is Optional',
            //message: Item_Sdgs課程.名稱,
            buttons: [
                {
                    text: '重新選擇',
                    role: 'cancel',
                    handler: () => {
                        //reload();
                    },
                },
                // {
                //     text: '重新選擇',
                //     role: 'confirm',
                //     handler: () => {
                //         navToPg_7_2_2(router, Item_Sdgs課程.Sdgs課程Id);
                //     },
                // },
            ]
        })
    }

    const _push_pg_7_2_2__competequiz = async (answer: string) => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        if (await push_pg_7_2_2__competequiz({
            p1: QuizToken,
            p2: answer,
        })) {
            //navToPg_1_1();
            //await reload();

            presentAlert({
                backdropDismiss: false,
                keyboardClose: false,
                header: '恭喜您通過測驗！',
                //subHeader: 'A Sub Header Is Optional',
                message: Item_Sdgs課程.名稱,
                buttons: [
                    // {
                    //     text: '稍後再在測驗',
                    //     role: 'cancel',
                    //     handler: () => {
                    //         //reload();
                    //     },
                    // },
                    {
                        text: '查詢積分紀錄',
                        role: 'confirm',
                        handler: () => {
                            navToPg_7_5(router);
                        },
                    },
                ]
            })
        }
    }

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={true} backButtonPath={`/tabs/7_2_1/${contractBonusId}`}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {hasLoaded &&
                    <>
                        <IonGrid className="ion-padding">
                            {/*<IonRow className={ styles.searchContainer }>*/}
                            {/*    <IonCol size="12">*/}
                            {/*        <IonSearchbar animated placeholder="Search for a product" />*/}
                            {/*    </IonCol>*/}
                            {/*</IonRow>*/}


                            {/*click={() => handleShowModal(item)}*/}
                            <IonRow>
                                <div className={styles_7_2_2.question}>
                                    <div className="title">請問：</div>
                                    <div className="text">{Item_Sdgs課程問題.QuestionText}</div>

                                    <div>試卷序號:{QuizToken}</div>
                                </div>

                                {List_Sdgs課程答案.map((Item_Sdgs課程答案, idx) => {
                                    return <Fragment key={Item_Sdgs課程答案.Sdgs課程答案Id}>
                                        <div className={styles_7_2_2.containerInner} onClick={
                                            () => {
                                                Item_Sdgs課程答案.Is解答 ?
                                                    // clickRight(
                                                    //     () => {
                                                    //         warnDialog({
                                                    //             warnType: "rightAnswer",
                                                    //             done: () => {
                                                    //                 deactivateWarnDialogModal();
                                                    //             }
                                                    //         })()
                                                    //     }
                                                    // )
                                                    _push_pg_7_2_2__competequiz(Item_Sdgs課程答案.Sdgs課程答案Id)
                                                    :
                                                    wrongAnswerDialog()
                                                    // clickWrong(
                                                    //     () => {
                                                    //         warnDialog({
                                                    //             warnType: "wrongAnswer",
                                                    //             done: () => {
                                                    //                 deactivateWarnDialogModal();
                                                    //             }
                                                    //         })()
                                                    //     });
                                            }
                                        }>
                                            <div className={styles_7_2_2.answer}>
                                                <div className="title">選擇 {1 + idx}.</div>
                                                <div className="text">{Item_Sdgs課程答案.答案文字}</div>
                                            </div>
                                        </div>
                                    </Fragment>;
                                })}

                                {/*<CardDetailFor_7_2 Item_Sdgs課程={Item_Sdgs課程} QrCode={QrCode} 已兌換次數={已兌換次數} hasAuthed={hasAuthed} noLink={true} onClickCapture={(ev)=> {*/}
                                {/*    if (!hasAuthed) {*/}
                                {/*        promptBrowserToLogin();*/}
                                {/*        ev.stopPropagation();*/}
                                {/*        return false;*/}
                                {/*    }*/}
                                {/*    return true;*/}
                                {/*}}*/}
                                {/*/>*/}

                                {/*{List_合約獎勵.map((item, index) => {*/}
                                {/*    return <Fragment key={item.合約獎勵Id}>*/}
                                {/*        */}
                                {/*    </Fragment>*/}
                                {/*})}*/}
                            </IonRow>
                        </IonGrid>
                    </>}
            </CustomPage>
        </IonPage>
    );
};

export default Pg_7_2_1;
